import React, { useState, useEffect } from 'react';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import awsExports from '../../aws-exports';
import { useNavigate } from 'react-router-dom';
import LogoHeader from './LogoHeader';
import Footer from './Footer';
import './LoginForm.css';
import useUserGroups from '../../hooks/useUserGroups';

Amplify.configure(awsExports);

function LoginForm({ setUser }) {
  const navigate = useNavigate();
  const [authUser, setAuthUser] = useState(null);
  const userGroups = useUserGroups(); 

  useEffect(() => {
    if (authUser) {
      setUser(authUser);
      // Redirigir según el tipoUser
      if (userGroups.includes('AdminGroup')) {
        navigate('/read'); 
      } else if (userGroups.includes('InvestorGroup')) {
        navigate('/upload'); 
      } else {
        navigate('/'); 
      }
    }
  }, [authUser, navigate, setUser, userGroups]); 

  return (
    <Authenticator
      signUpAttributes={[]}
      components={{
        Header: LogoHeader,
        Footer: Footer,
      }}
    >
      {({ signOut, user }) => {
        if (user && !authUser) {
          setAuthUser(user);
        }

        return (
          <>
            <h1>Dear {user?.username}</h1>
            <button onClick={signOut} className='amplify-button amplify-button--primary'>Sign out</button>
          </>
        );
      }}
    </Authenticator>
  );
}

export default LoginForm;
